import { call, put, select, take } from 'redux-saga/effects';
import { HaveIBeenPwned, NBXReferral } from 'services';
import { setCardPartnershipCodeToLs } from '@nbx/frontend-helpers/services';
import { isMobileWebBrowser } from 'helpers/utils';

import ERRORS from 'constants/errors';
import { createLogger } from 'helpers/logger';
import STEPS from 'constants/steps';
import {
  actionSendEmailVerification,
  setError,
  stopLoading,
  actionVerifyLogin,
  setStep,
  actionFirebaseAddPhoneNumber
} from 'reduxConfig/auth.creators';

import authTypes from 'reduxConfig/auth.types';

import { isOAuthRedirect, handleOAuthRedirect } from 'helpers/oauthRedirect';

const log = createLogger('[auth-saga] processFirebaseLoginSuccess:');

export function* processFirebaseLoginSuccess({ password, userCredential, isNewUser }) {
  try {
    const { user } = userCredential;

    const referralCode = yield select(state => state.referralCode);
    const cardPartnershipCode = yield select(state => state.cardPartnershipCode);

    log.info(`referralCode=${referralCode}, cardPartnershipCode=${cardPartnershipCode}`);
    if (referralCode || cardPartnershipCode) {
      const token = yield call(window.FIREBASE.getIdTokenFromNative);
      if (referralCode) {
        try {
          yield call(NBXReferral.postUsedReferral, referralCode, token);
        } catch (e) {
          console.error(`failed to postUsedReferral, referralCode=${referralCode} error=${e.message}`);
          throw e;
        }
      }
      if (cardPartnershipCode) {
        log.info('[cardPartnershipCode] postCardPartnership', cardPartnershipCode);
        yield call(setCardPartnershipCodeToLs, cardPartnershipCode);
        yield call(NBXReferral.postCardPartnership, cardPartnershipCode, token);
        log.info('[cardPartnershipCode] postCardPartnership - done');
      }
    }

    if (isNewUser) {
      window.dataLayer?.push({
        event: 'sign_up',
        method: userCredential?.providerId
      });
    }

    if (!user?.emailVerified) {
      window.dataLayer?.push({
        event: 'email_verification_begin'
      });
      yield put(actionSendEmailVerification(user.email));
    }
    // && isNewUser // NBXStorage.setItem(`TOS-ACCEPTED-${user.email}`, true, { useLocalStorage: true });
    else {
      if (password) {
        const pwned = yield call(HaveIBeenPwned.isPasswordPwned, password);
        if (pwned) sessionStorage.setItem('password-insecure', true);
      }

      const isEnrollFirebaseSms2faOnSignup = yield select(state => state.isEnrollFirebaseSms2faOnSignup);
      const addPhoneNumberError = yield select(state => state.addPhoneNumberError);

      if (
        (isNewUser || addPhoneNumberError) &&
        (isEnrollFirebaseSms2faOnSignup || user.email.endsWith('@nbx.com'))
      ) {
        yield put(setStep(STEPS.addPhoneNumber));
        log.info('add phone number, previous error', addPhoneNumberError);
        yield put(actionFirebaseAddPhoneNumber({ userCredential }));
        yield take([
          authTypes.FIREBASE_ADD_PHONE_NUMBER_SUCCESS,
          authTypes.FIREBASE_ADD_PHONE_NUMBER_ERROR,
          authTypes.FIREBASE_ADD_PHONE_NUMBER_SKIPPED
        ]);
        yield put(setStep(STEPS.RESET));
      }

      if (isOAuthRedirect()) {
        handleOAuthRedirect(user);
        return;
      }

      if (isNewUser && isMobileWebBrowser) {
        log.info('redirect to install...');
        window.location.href = '/install';
      } else {
        log.info('actionVerifyLogin...');
        const idToken = yield call(window.FIREBASE.getIdTokenFromNative);
        yield put(actionVerifyLogin({ idToken }));
      }
    }
  } catch (e) {
    log.error('Error in processFirebaseLoginSuccess', e.message);
    yield put(setError(ERRORS.login));
  } finally {
    yield put(stopLoading());
  }
}
